export default "__VITE_ASSET__DD0_z2Sk__"